import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '@saucelabs/sl-component-grid';
import { NavLink } from '@saucelabs/sl-component-router';
import { Modal } from '@saucelabs/sl-component-overlay';
import Well from '@saucelabs/sl-component-well';
import modalConnect from '@saucelabs/sl-container-modal';
import { apiBaseUrls } from '@saucelabs/sl-util-config';

import { ACCOUNT_EXPIRED_MODAL_NAME } from '../constants';
import Styles from './AccountExpiredModal.styles';

const AccountExpiredModal = ({ show, handleLogout }) => (
  <Modal
    dialogClassName="accountExpiredModal"
    fitWindow
    show={show}
  >
    <Modal.Header>
      <Modal.Title>Your Sauce Labs Virtual Cloud Trial has Expired </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Row>
        <Col sm={6}>
          <div className={Styles['modal-copy']} >
            <p>
              We&lsquo;re sorry, your Sauce Labs Virtual Cloud account has expired.
              If you feel you are seeing this mesage in error, please contact Sauce Support,
              or your administrator.
            </p>
            <div className={Styles['link-group']} >
              <a
                href={apiBaseUrls.billing}
                rel="noopener noreferrer"
                target="_blank"
              >
                Sauce Labs Pricing and Plans
              </a>
              <a
                href="https://support.saucelabs.com/hc/en-us"
                rel="noopener noreferrer"
                target="_blank"
              >
                Contact Support
              </a>
              <NavLink
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  handleLogout();
                }}
                to="#"
              >
                Sign out
              </NavLink>
            </div>
          </div>
        </Col>
        <Col sm={6}>
          <div className={Styles['well-wrapper']} >
            <Well className={Styles.proTip}>
              <p><strong>Looking for Real Devices?</strong></p>
              <p>
                If you already have a Sauce Labs Real Device Cloud account, you may access
                your account below.
              </p>
              <a
                href="/signup/test_object"
                rel="noopener noreferrer"
                target="_blank"
              >
                Access Real Devices
              </a>
            </Well>
          </div>
        </Col>
      </Row>
    </Modal.Body>
  </Modal>
);


AccountExpiredModal.propTypes = {
  handleLogout: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default modalConnect(ACCOUNT_EXPIRED_MODAL_NAME, AccountExpiredModal);
export { AccountExpiredModal };
